import { serviceTypeColour } from './colour';

/**
 * What a mark stands for: a service type of the shop's (coloured by its place in the list), or
 * one of the leftovers, "No service type" and "Not tied to a job" (the muted hatch). A row of
 * revenue by service type is one, and so is a segment of a person's mix.
 */
export type Marked = { kind: 'type'; sortOrder: number } | { kind: 'none' | 'not-tied' };

/**
 * A kind of work's mark, as a swatch beside its name or as a bar: its type's colour, or the
 * leftovers' muted hatch. Never the only carrier: whatever it marks is named in text beside it.
 */
export function Mark({
  of,
  className,
  width,
}: {
  of: Marked;
  className: string;
  /** A bar's length; a swatch has none. */
  width?: string;
}) {
  return of.kind === 'type' ? (
    <span
      aria-hidden="true"
      className={className}
      style={{ width, backgroundColor: serviceTypeColour(of.sortOrder) }}
    />
  ) : (
    <span
      aria-hidden="true"
      className={`service-type-hatch ${className}`}
      style={{ width }}
    />
  );
}
